import React from 'react';

interface EmptyConversationsListProps {
  onSearchJob?: () => void;
}

/**
 * Empty state for conversations list
 * Shows when user has no conversations
 */
const EmptyConversationsList: React.FC<EmptyConversationsListProps> = ({ onSearchJob }) => {
  return (
    <div className="flex flex-col justify-center items-center gap-5 w-full h-full px-6">
      {/* Illustration */}
      <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#015FA6]/10 to-[#015FA6]/5 flex items-center justify-center">
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
            stroke="#015FA6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Text */}
      <div className="text-center">
        <p className="font-manrope font-semibold text-base text-[#374151]">
          No conversations yet
        </p>
        <p className="font-manrope font-normal text-sm text-[#9CA3AF] mt-1">
          Start exploring job opportunities
        </p>
      </div>

      {/* Search Job button */}
      <button
        onClick={onSearchJob}
        className="flex flex-row justify-center items-center gap-2 px-5 py-2.5 bg-[#015FA6] text-white rounded-xl font-manrope font-medium text-sm shadow-[0_2px_4px_rgba(1,95,166,0.2)] hover:bg-[#014580] hover:shadow-[0_4px_8px_rgba(1,95,166,0.25)] active:scale-95 transition-all duration-150"
      >
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 19L14.65 14.65"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Search Jobs
      </button>
    </div>
  );
};

export default EmptyConversationsList;
